module.exports = __webpack_public_path__ + "static/hv-properties-logo-b029ee07d3fe9217f309cf666e71fb45.jpg";